import PropTypes from "prop-types";
import ParticleTwo from "../../particles/ParticleTwo";
import { Link } from "react-router-dom";
const BreadcrumbBornToTradePodcast = () => {
  return (
    <div
      className="ht__bradcaump__area__resource"
      style={{
        background: `rgba(0, 0, 0, 0) url(${
          process.env.PUBLIC_URL + "/images/about/bull_right_side.jpg"
        }) repeat scroll center center/105% 100%`,
      }}
    >
      <div className="ht__bradcaump__container__resource">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <h1>Born to Trade Podcast</h1>
              <p>
                Where market insights meet meaningful conversations, tune into
                expert-led discussions that turn trading talk into real-world
                wisdom.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Listen Now
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* <ParticleTwo /> */}
    </div>
  );
};

BreadcrumbBornToTradePodcast.propTypes = {
  title: PropTypes.string,
};

export default BreadcrumbBornToTradePodcast;
